var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-geo-json',{key:"achare",attrs:{"geojson":_vm.chartAchare,"options":_vm.geoJsonOptions,"optionsStyle":_vm.styleFunction,"name":"Áreas de fondeo","layer-type":"overlay","pane":"tilePane"}})}
var staticRenderFns = []

export { render, staticRenderFns }